import { ListReferenceNameCell } from './ListReferenceNameCell';
import { ListReferenceMessageMediumCell } from './ListReferenceMessageMediumCell';
import { ListReferenceTypeCell } from './ListReferenceTypeCell';
import { ListReferenceStatusCell } from './ListReferenceStatusCell';
import { ListReferenceLastModifiedCell } from './ListReferenceLastModifiedCell';
import { ListReference, CreatorAndModifierById } from '../../../types';

type ListReferenceRowProps = {
  listReference: ListReference;
  index: number;
  creatorsAndModifiersById: CreatorAndModifierById;
};

export const ListReferenceRow = ({
  listReference,
  index,
  creatorsAndModifiersById,
}: ListReferenceRowProps) => (
  <>
    <ListReferenceNameCell listReference={listReference} rowIndex={index} />
    <ListReferenceMessageMediumCell listReference={listReference} rowIndex={index} />
    <ListReferenceTypeCell listReference={listReference} rowIndex={index} />
    <ListReferenceStatusCell listReference={listReference} rowIndex={index} />
    <ListReferenceLastModifiedCell
      listReference={listReference}
      rowIndex={index}
      creatorsAndModifiersById={creatorsAndModifiersById}
    />
  </>
);
